import {HttpClient, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { ProgramDTO } from "src/app/program/program.service";
import {environment} from "src/environments/environment";

export interface PortfolioStatusDTO {
  productId: number;
  productName: string;
  enablerProjectId?: number;
  enablerProjectName?: string;
  enablerName?: string;
  phase: string;
  previousPhase: string;
  valueStream: string;
  tags: string[];
  hosting?: string;
  addedDate: string;
  pilot: string;
  productOwners: any[];

  preFramingStartDate: string;
  preFramingEndDate: string;
  framingStartDate: string;
  framingEndDate: string;
  buildStartDate: string;
  buildEndDate: string;
  growthStartDate: string;
  growthEndDate: string;
  maintainStartDate: string;
  maintainEndDate: string;

  currentPhaseStatus: string;
  onTimeCount: number;
  totalObjective: number;
  description: string;
  showInSearchProduct: boolean;
  productOwnerStatus: string;
  productType: string;
  discipline: string;
  domain: string;
  rationalizationDecision: string;
  branches: string[];
  dataProduct: boolean;
  enablerProduct: boolean;
  
  // used for rationalization matrix
  businessProcess: string;
  program: ProgramDTO;
  workstream: any;
  workstreamCreationDate: string;
  deliveryCenter: string;
  deliveryCenterTagLabel?: string;
  entityOwner?: string;
  entityOwnerTagLabel?: string;
  programRequesters?: string[];
  productRequesters?: string[];
  dataProductPo?: string;
  dataProductImplementationSquad?: string;
  dataDomains?: string[];
  sourceSystem?: string;
  typeOfNeed?: string;
}

export interface PortfolioStatusResponseDTO {
  products: PortfolioStatusDTO[];

  // Null when the user has not customized them: defaults must then be used
  tags: string[] | null;
  filters: string[] | null;
  rationalizationTags: string[] | null;
  rationalizationFilters: string[] | null;
  cardColor: string | null;
}

export interface UserPortfolioPreferenceDTO {
  tags: string[];
  filters: string[];
  cardColor: string | null;
}

@Injectable({
  providedIn: "root",
})
export class PortfolioStatusService {
  private readonly apiUrl = `${environment.webProtocol}://${environment.serverUrl}/api/portfolio-status`;

  constructor(private readonly http: HttpClient) {
  }

  saveUserPreferences(
    preferences: UserPortfolioPreferenceDTO,
    portfolioId?: number,
    programId?: number,
    rationalization = false,
  ): Observable<any> {
    let httpParams = new HttpParams().set("rationalization", rationalization);
    if (portfolioId !== undefined && portfolioId !== null) {
      httpParams = httpParams.set("portfolioId", portfolioId);
    }
    if (programId !== undefined && programId !== null) {
      httpParams = httpParams.set("programId", programId);
    }
    return this.http.post(`${this.apiUrl}/preferences`, preferences, {params: httpParams});
  }

  getPortfolioStatus(portfolioId?: number, programId?: number): Observable<PortfolioStatusResponseDTO> {
    let httpParams = new HttpParams();
    if (portfolioId !== undefined && portfolioId !== null) {
      httpParams = httpParams.set("portfolioId", portfolioId);
    }
    if (programId !== undefined && programId !== null) {
      httpParams = httpParams.set("programId", programId);
    }
    return this.http.get<PortfolioStatusResponseDTO>(`${this.apiUrl}`, {params: httpParams});
  }



  updatePhase(productId: number, phase: string, portfolioId?: number, programId?: number): Observable<any> {
    let httpParams = new HttpParams().set("phase", phase);
    if (portfolioId !== undefined && portfolioId !== null) {
      httpParams = httpParams.set("portfolioId", portfolioId);
    }
    if (programId !== undefined && programId !== null) {
      httpParams = httpParams.set("programId", programId);
    }
    return this.http.post(`${this.apiUrl}/${productId}/phase`, {}, {params: httpParams});
  }

  deleteProduct(productId: number, portfolioId?: number, programId?: number): Observable<any> {
    let httpParams = new HttpParams();
    if (portfolioId !== undefined && portfolioId !== null) {
      httpParams = httpParams.set("portfolioId", portfolioId);
    }
    if (programId !== undefined && programId !== null) {
      httpParams = httpParams.set("programId", programId);
    }
    return this.http.get(`${this.apiUrl}/delete/${productId}`, {params: httpParams});
  }
}
